import React from "react";
import PageNavHeader from "../PageNavHeader";

const headingStyle = { fontFamily: "Inter, sans-serif", fontWeight: 800, fontSize: "clamp(32px, 9vw, 56px)", lineHeight: "100%", letterSpacing: "-0.04em" };
const subtitleStyle = { fontFamily: "Inter, sans-serif", fontWeight: 400, fontSize: "clamp(16px, 4vw, 28px)", lineHeight: "140%", letterSpacing: "-0.04em", color: "#FFFFFF", maxWidth: "1100px" };

const PrintMaterialNavHeader = () => (
  <PageNavHeader mobileAlign="left">
    <h1 className="lowercase" style={headingStyle}>
      <span style={{ color: "#9747FF" }}>print </span>
      <span style={{ color: "#FFFFFF" }}>material</span>
    </h1>
    <p className="lowercase md:mx-auto mt-6 md:mt-10" style={subtitleStyle}>
      use our print materials & qr codes so your customers can download beɘmz & engage with you.
    </p>
  </PageNavHeader>
);

export default PrintMaterialNavHeader;
